import React from "react";
import { Card, Divider } from "antd";
import "./stylescroll.css";
const DisplayCard = () => {
  return (
    <Card
      title={
        <div className="moving-gradient-header">
          <span>CONSULTING SERVICES</span>
        </div>
      }
      size="small"
      headStyle={{
        padding: 0,
        borderBottom: "none",
      }}
      bodyStyle={{
        padding: 24,
      }}
      style={{ borderRadius: 16, maxHeight: "fit-content", overflow: "hidden" }}
    >
      <div
        style={{
          width: "100%",
          gap: 32,
          padding: "12px 0",
        }}
      >
        <div
          style={{
            flex: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 24,
          }}
        >
          <div
            style={{
              textAlign: "left",
              fontSize: 16,
              color: "#34495e",
              fontWeight: 500,
              padding: "0 12px",
              flex: 1,
            }}
          >
            For all your compensation consulting, HR support and leadership
            development services, get in touch with us.
          </div>
          <button
            className="btn"
            onClick={() => {
              window.open(
                "https://jerhrgroup.com/contact-jer-hr-group/",
                "_blank"
              );
            }}
            style={{ minWidth: 150, padding: "10px" }}
          >
            JER HR Group
          </button>
        </div>
        <Divider />
        <div
          style={{
            flex: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 24,
          }}
        >
          <div
            style={{
              textAlign: "left",
              fontSize: 16,
              color: "#34495e",
              fontWeight: 500,
              padding: "0 12px",
              flex: 1,
            }}
          >
            For leadership development training and executive coaching, please
            contact Nexa Learning.
          </div>
          <button
            className="btn"
            onClick={() => {
              window.open("https://nexalearning.com", "_blank");
            }}
            style={{ minWidth: 150, padding: "10px" }}
          >
            Nexa Learning
          </button>
        </div>
      </div>
    </Card>
  );
};

export default DisplayCard;
